export default "__VITE_ASSET__CAY_AZtx__"